<template>
  <v-cotainer fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Product Repair
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn outlined @click="addDamage()">
            <v-icon left color="teal">add</v-icon>
            New Item
          </v-btn>
          <!-- <router-link to="/Dashboard">
            <v-btn icon>
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </router-link> -->
        </v-toolbar>

        <v-data-table
          :headers="manufHeader"
          :items="productMenufsList"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <b>{{ getProductName(props.item.productId) }}</b>
            </td>
            <td>
              <b>{{ getCustomerName(props.item.buyerId) }}</b>
            </td>
            <td>
              <b>{{
                new Date(props.item["date"]).toLocaleDateString("en-GB")
              }}</b>
            </td>
            <td>
              <b>{{ props.item.status }}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="edit(props.item)">
                <v-icon color="pink">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deletefinal(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- Start Product Set Dialog -->
    <v-dialog v-model="menufDialog" persistent max-width="1000px">
      <v-card persistent v-if="currentMenuf">
        <v-card-title class="primary white--text">
          <span class="headline">Damage Product</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm4>
                <v-switch
                  v-model="currentMenuf.isBuyer"
                  :label="`${
                    currentMenuf.isBuyer ? 'Sale Order' : 'Purchase Order'
                  }`"
                ></v-switch>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-select
                  v-bind:items="
                    currentMenuf.isBuyer ? buyersByBrand : sellersByBrand
                  "
                  v-model="currentMenuf.buyerId"
                  :label="
                    currentMenuf.isBuyer
                      ? 'Select or add Buyer'
                      : 'Select or add Seller'
                  "
                  autocomplete
                  :item-text="'text'"
                  :item-value="'value'"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm4>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datePicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="currentMenuf.date"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="currentMenuf.date"
                    @input="datePicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm4>
                <v-select
                  dense
                  autocomplete
                  :items="productsByBrand"
                  label="Product"
                  v-model="currentMenuf.productId"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  type="number"
                  v-model.number="currentMenuf.quantity"
                  label="Quantity"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-radio-group
                  :key="'deposite-amount-total'"
                  v-model="currentMenuf.status"
                  row
                >
                  <v-radio :label="`Pending`" :value="`Pending`"></v-radio>
                  <v-radio :label="`Completed`" :value="`Completed`"></v-radio>
                  <v-radio
                    :label="`Not Completed`"
                    :value="`Not Completed`"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 sm4>
                <v-textarea
                  name="input-7-1"
                  outlined
                  label="Remark"
                  v-model="currentMenuf.remark"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="menufDialog = false" flat
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            @click="updateFinal()"
            v-if="currentMenuf['.key']"
            flat
            >Update</v-btn
          >
          <v-btn v-else color="blue darken-1" @click="saveFinal()" flat
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-cotainer>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  data() {
    return {
      datePicker: null,
      menufDialog: false,
      currentMenuf: null,
      manufHeader: [
        { text: "Product Name", value: "deposit - ID" },
        { text: "Customer Name", value: "deposit - ID" },
        { text: "Date", value: "name" },
        { text: "Status", value: "name" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "productMenufs",
        this.$root.$firebaseRefs.productRepair
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
    this.$bindAsArray(
      "buyers",
      this.$root.$firebaseRefs.buyer
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "sellers",
        this.$root.$firebaseRefs.seller
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    productsByBrand() {
      return this.products
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    productMenufsList() {
      return this.productMenufs;
    },
    buyersByBrand() {
      return this.buyers
        .filter((item) => {
          return item["brand"] === this.selectedBrand;
        })
        .map((item) => {
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    sellersByBrand() {
      return this.sellers
        .filter((item) => {
          return item["brand"] === this.selectedBrand;
        })
        .map((item) => {
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
  },
  methods: {
    saveFinal() {
      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      this.$root.$firebaseRefs.productRepair.push(this.currentMenuf);
      this.menufDialog = false;
    },
    getCustomerName(id) {
      let buyer = this.buyersByBrand.find((i) => i["value"] == id);
      let seller = this.sellersByBrand.find((i) => i["value"] == id);
      if (!buyer && !seller) {
        return "DELETED CUSTOMER";
      }
      return buyer ? buyer.text : seller.text;
    },
    addDamage() {
      this.currentMenuf = {
        brand: this.selectedBrand,
        date: new Date().toISOString().substr(0, 10),
        productId: null,
        quantity: 1,
        status: "Pending",
        remark: "",
        buyerId: null,
        isBuyer: true,
      };
      this.menufDialog = true;
    },
    edit(productSet) {
      this.currentMenuf = productSet;
      this.currentMenuf.date = new Date(this.currentMenuf.date)
        .toISOString()
        .substr(0, 10);
      this.menufDialog = true;
    },
    updateFinal() {
      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      let key = this.currentMenuf[".key"];
      delete this.currentMenuf[".key"];
      this.$root.$firebaseRefs.productRepair
        .child(key)
        .update(this.currentMenuf)
        .then((data) => {
          this.currentMenuf = null;
          this.menufDialog = false;
        })
        .catch((error) => {
          console.log(error.code, error.message);
        });
    },
    deleteMenuf(productSet) {
      if (window.confirm("Do you want to Delete ?")) {
        this.currentMenuf = productSet;
        this.convertBack("delete");
      }
    },
    getProductName(key) {
      return this.products.find((item) => item[".key"] == key).name;
    },

    deletefinal(item) {
      if (confirm("Are You sure?")) {
        this.$root.$firebaseRefs.productRepair.child(item[".key"]).remove();
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Settings/ProductRepair/ProductRepair.vue